const handleErrors = async (response, customHandler) => {
  if (!response.ok) {
    if (customHandler) {
      await customHandler(response);
      // if custom handler doesn't throw we go to the next block
    }
    if (response.statusText) {
      throw Error(response.statusText);
    }
    return response.text().then((text) => {
      throw new Error(text);
    });
  }

  return response.json();
};

export default handleErrors;
